import React, { useState } from 'react';
import RoulettePage from './RoulettePage';
import TexasHoldemPage from './TexasHoldemPage';
import SlotsPage from './SlotsPage';
import BlackjackPage from './BlackjackPage';
import MinesPage from './MinesPage';
import KenoPage from './KenoPage';
import SportsBettingPage from '../sports/SportsBettingPage';
import { PgHeader } from '../ui';
import { fmtTokens } from '../../utils/helpers';

function CasinoPage({ user, userData, onUserDataChange, onTokenAdjustmentChange, isMobile }) {
  const [selectedGame, setSelectedGame] = useState(null);
  if (!user || !userData) {
    return (
      <div className="v2-page">
        <PgHeader title="Casino" sub="Please log in to access the casino." />
      </div>
    );
  }

  if (selectedGame === "roulette") {
    return <RoulettePage user={user} userData={userData} onUserDataChange={onUserDataChange} onTokenAdjustmentChange={onTokenAdjustmentChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  if (selectedGame === "holdem") {
    return <TexasHoldemPage user={user} userData={userData} onUserDataChange={onUserDataChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  if (selectedGame === "slots") {
    return <SlotsPage user={user} userData={userData} onUserDataChange={onUserDataChange} onTokenAdjustmentChange={onTokenAdjustmentChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  if (selectedGame === "blackjack") {
    return <BlackjackPage user={user} userData={userData} onUserDataChange={onUserDataChange} onTokenAdjustmentChange={onTokenAdjustmentChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  if (selectedGame === "mines") {
    return <MinesPage user={user} userData={userData} onUserDataChange={onUserDataChange} onTokenAdjustmentChange={onTokenAdjustmentChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  if (selectedGame === "keno") {
    return <KenoPage user={user} userData={userData} onUserDataChange={onUserDataChange} onTokenAdjustmentChange={onTokenAdjustmentChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  if (selectedGame === "sportsbook") {
    return <SportsBettingPage user={user} userData={userData} onUserDataChange={onUserDataChange} onBack={() => setSelectedGame(null)} isMobile={isMobile} />;
  }

  const games = [
    {
      id: 'roulette',
      name: 'Roulette',
      icon: '🎡',
      desc: 'American Roulette with all standard bets. Spin the wheel!',
      accent: '#DC143C',
      accentDim: 'rgba(220,20,60,0.15)',
      accentBorder: 'rgba(220,20,60,0.5)',
      shine: 'rgba(220,20,60,0.08)',
    },
    {
      id: 'slots',
      name: 'Slots',
      icon: '🎰',
      desc: 'Pull the lever and match the reels for massive payouts.',
      accent: '#9B59B6',
      accentDim: 'rgba(155,89,182,0.15)',
      accentBorder: 'rgba(155,89,182,0.5)',
      shine: 'rgba(155,89,182,0.08)',
    },
    {
      id: 'holdem',
      name: "Texas Hold'em",
      icon: '♠️',
      desc: 'Multiplayer poker. Blinds 0.25/0.5. Min 10🔵 to join.',
      accent: '#228B22',
      accentDim: 'rgba(34,139,34,0.15)',
      accentBorder: 'rgba(34,139,34,0.5)',
      shine: 'rgba(34,139,34,0.08)',
    },
    {
      id: 'blackjack',
      name: 'Blackjack',
      icon: '🃏',
      desc: 'Beat the dealer to 21. Classic casino rules.',
      accent: '#4169E1',
      accentDim: 'rgba(65,105,225,0.15)',
      accentBorder: 'rgba(65,105,225,0.5)',
      shine: 'rgba(65,105,225,0.08)',
    },
    {
      id: 'mines',
      name: 'Mines',
      icon: '💎',
      desc: 'Reveal diamonds, avoid mines. Cash out anytime!',
      accent: '#00BFA5',
      accentDim: 'rgba(0,191,165,0.15)',
      accentBorder: 'rgba(0,191,165,0.5)',
      shine: 'rgba(0,191,165,0.08)',
    },
    {
      id: 'keno',
      name: 'Keno',
      icon: '🎱',
      desc: 'Pick your tiles and watch the draw. Up to 100,000x payout!',
      accent: '#F59E0B',
      accentDim: 'rgba(245,158,11,0.15)',
      accentBorder: 'rgba(245,158,11,0.5)',
      shine: 'rgba(245,158,11,0.08)',
    },
    {
      id: 'sportsbook',
      name: 'Sportsbook',
      icon: '🏈',
      desc: 'Bet on real games. Moneyline, spreads, totals & player props.',
      accent: '#E67E22',
      accentDim: 'rgba(230,126,34,0.15)',
      accentBorder: 'rgba(230,126,34,0.5)',
      shine: 'rgba(230,126,34,0.08)',
    },
  ];

  const crew = userData.crewmateTokens || 0;
  const imp  = userData.imposterTokens || 0;

  return (
    <div className="v2-page">
      <PgHeader
        title="Casino"
        sub={
          <span>
            Balance: <strong style={{ color: 'var(--crew)' }}>🔵 {fmtTokens(crew)}</strong>
            <span style={{ color: 'var(--text-3)' }}> · </span>
            <strong style={{ color: 'var(--red)' }}>🔴 {fmtTokens(imp)}</strong>
          </span>
        }
      />

      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: isMobile ? 10 : 14,
      }}>
        {games.map(g => (
          <GameCard key={g.id} game={g} onSelect={() => !g.comingSoon && setSelectedGame(g.id)} isMobile={isMobile} />
        ))}
      </div>
    </div>
  );
}

function GameCard({ game, onSelect, isMobile }) {
  const [hover, setHover] = useState(false);
  const g = game;
  return (
    <div
      onClick={onSelect}
      onMouseEnter={() => !g.comingSoon && setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: hover ? 'var(--elevated)' : 'var(--card)',
        border: `1px solid ${hover ? g.accent + '66' : 'var(--border)'}`,
        borderRadius: isMobile ? 12 : 14,
        padding: isMobile ? '16px 14px' : 22,
        cursor: g.comingSoon ? 'default' : 'pointer',
        opacity: g.comingSoon ? 0.5 : 1,
        transition: 'all 0.18s ease',
        transform: hover ? 'translateY(-3px)' : 'none',
        boxShadow: hover ? `0 12px 36px ${g.accent}22` : 'none',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: 2,
        background: g.accent,
        opacity: hover ? 1 : 0.4,
        transition: 'opacity 0.18s',
      }} />
      {g.comingSoon && (
        <div style={{
          position: 'absolute', top: 10, right: 10,
          fontSize: 9, fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
          letterSpacing: '0.05em', color: '#FFD700',
          background: 'rgba(255,215,0,0.12)', padding: '2px 7px', borderRadius: 4,
        }}>SOON</div>
      )}
      <div style={{ fontSize: isMobile ? 26 : 34, marginBottom: isMobile ? 10 : 12, marginTop: 4, lineHeight: 1 }}>
        {g.icon}
      </div>
      <div style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: isMobile ? 13 : 15, marginBottom: 6, color: 'var(--text)' }}>
        {g.name}
      </div>
      {!isMobile && (
        <div style={{ fontSize: 13, color: 'var(--text-2)', lineHeight: 1.4, marginBottom: 14 }}>
          {g.desc}
        </div>
      )}
      {!g.comingSoon && (
        <button
          type="button"
          style={{
            width: '100%',
            padding: isMobile ? '8px 0' : 9,
            background: g.accent + '18',
            border: `1px solid ${g.accent}44`,
            borderRadius: 8,
            cursor: 'pointer',
            fontFamily: "'Orbitron', sans-serif",
            fontSize: isMobile ? 10 : 11,
            fontWeight: 700,
            letterSpacing: '0.1em',
            color: g.accent,
          }}
        >
          PLAY NOW
        </button>
      )}
    </div>
  );
}

export default CasinoPage;
